import { NumberInput, NumberInputOnBlur } from '../NumberInput';

type PercentProps = Parameters<typeof NumberInput>[0] & { notInQuestionnaire?: boolean };

const Percent: React.FC<PercentProps> = (props) =>
  props.notInQuestionnaire ? <NumberInput suffix='%' {...props} /> : <NumberInputOnBlur suffix='%' {...props} />;

export default Percent;
